(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // tabs
  document.querySelectorAll('[data-yr-tabs]').forEach(function(root){
    var btns = root.querySelectorAll('.yr-tab');
    var panels = root.querySelectorAll('.yr-panel');
    btns.forEach(function(btn, i){
      btn.addEventListener('click', function(){
        btns.forEach(function(b){ b.setAttribute('aria-selected','false'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.setAttribute('aria-selected','true');
        var t = root.querySelector('#' + btn.getAttribute('aria-controls'));
        if(t) t.classList.add('is-active');
      });
    });
  });
  // countdown
  document.querySelectorAll('[data-yr-countdown]').forEach(function(el){
    var end = new Date(el.getAttribute('data-yr-countdown')).getTime();
    if(isNaN(end)) return;
    var n = el.querySelectorAll('[data-unit]');
    function tick(){
      var d = Math.max(0, end - Date.now());
      var s = Math.floor(d/1000);
      var map = { days: Math.floor(s/86400), hours: Math.floor(s%86400/3600), mins: Math.floor(s%3600/60), secs: s%60 };
      n.forEach(function(node){ var k = node.getAttribute('data-unit'); var v = map[k]||0; node.textContent = (v<10&&k!=='days'?'0':'') + v; });
    }
    tick(); setInterval(tick,1000);
  });
  // scroll reveal
  if(!reduce && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('yr-in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -10% 0px',threshold:.12});
    document.querySelectorAll('.yr-reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.yr-reveal').forEach(function(el){ el.classList.add('yr-in'); }); }
})();
(function(){
  var THRESHOLD = 50;
  function money(c){ return "$" + (c/100).toFixed(2); }
  function build(total){
    var pct = Math.min(100, Math.round(total / (THRESHOLD*100) * 100));
    var wrap = document.createElement("div");
    wrap.className = "yr-ship-bar" + (total >= THRESHOLD*100 ? " yr-ship-bar--done" : "");
    var t = document.createElement("div"); t.className = "yr-ship-bar__txt";
    t.textContent = total >= THRESHOLD*100 ? "You have unlocked free shipping" : "Add " + money(THRESHOLD*100 - total) + " more for free shipping";
    var tr = document.createElement("div"); tr.className = "yr-ship-bar__track";
    var sp = document.createElement("span"); sp.style.width = pct + "%";
    tr.appendChild(sp); wrap.appendChild(t); wrap.appendChild(tr);
    return wrap;
  }
  var busy = false;
  function inject(){
    if (busy) return;
    try {
      var isCart = location.pathname.indexOf("/cart") === 0;
      var drawer = document.querySelector("cart-drawer[open], cart-drawer.active, .cart-drawer.active");
      if (!isCart && !drawer) return;
      if (document.querySelector(".yr-ship-bar")) return;
      var host = document.querySelector(".cart__items, cart-items, .drawer__inner form, form[action=\"/cart\"]");
      if (!host || !host.parentNode) return;
      busy = true;
      fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          if (document.querySelector(".yr-ship-bar")) return;
          host.parentNode.insertBefore(build(cart.total_price || 0), host);
        })
        .catch(function(){})
        .then(function(){ busy = false; });
    } catch (e) { busy = false; }
  }
  var timer = null;
  function debounced(){ if (timer) clearTimeout(timer); timer = setTimeout(inject, 300); }
  if (document.readyState !== "loading") { inject(); } else { document.addEventListener("DOMContentLoaded", inject); }
  ["cart:updated","cart:refresh","cart:change"].forEach(function(ev){ document.addEventListener(ev, debounced); });
  try { new MutationObserver(debounced).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
/* === mobile sticky add-to-cart === */
(function(){
  try{
    if(!window.matchMedia) return;
    if(!window.matchMedia("(max-width: 749px)").matches) return;
    var form = document.querySelector("product-form form[action*=\"/cart/add\"]") || document.querySelector("form[action*=\"/cart/add\"]");
    if(!form) return;
    var submit = form.querySelector(".product-form__submit") || form.querySelector("button[type=submit][name=add]") || form.querySelector("button[type=submit]");
    if(!submit) return;
    if(document.querySelector(".yr-sticky-atc")) return;
    var titleEl = document.querySelector(".product__title");
    var priceEl = document.querySelector(".product__info-container .price") || document.querySelector(".price");
    var bar = document.createElement("div"); bar.className = "yr-sticky-atc";
    var meta = document.createElement("div"); meta.className = "yr-sticky-atc__meta";
    var t = document.createElement("div"); t.className = "yr-sticky-atc__title";
    t.textContent = titleEl ? titleEl.textContent.replace(/\s+/g," ").trim() : "Add to cart";
    var p = document.createElement("div"); p.className = "yr-sticky-atc__price";
    p.textContent = priceEl ? priceEl.textContent.replace(/\s+/g," ").trim() : "";
    meta.appendChild(t); meta.appendChild(p);
    var btn = document.createElement("button"); btn.type = "button"; btn.className = "yr-sticky-atc__btn"; btn.textContent = "Add to cart";
    bar.appendChild(meta); bar.appendChild(btn);
    document.body.appendChild(bar);
    var raf = 0;
    function update(){
      raf = 0;
      try{
        var r = submit.getBoundingClientRect();
        var open = document.querySelector("cart-drawer[open]");
        var on = r.bottom < 0 && !open;
        bar.classList.toggle("is-on", on);
        document.body.classList.toggle("yr-has-sticky-atc", on);
      }catch(e){}
    }
    function onScroll(){ if(raf) return; raf = window.requestAnimationFrame ? window.requestAnimationFrame(update) : setTimeout(update, 60); }
    window.addEventListener("scroll", onScroll, {passive:true});
    window.addEventListener("resize", onScroll);
    btn.addEventListener("click", function(){
      try{
        var idInput = form.querySelector("input[name=\"id\"]");
        if(idInput && idInput.value){
          submit.click();
          bar.classList.remove("is-on");
          document.body.classList.remove("yr-has-sticky-atc");
        } else {
          var box = document.querySelector(".product__info-container") || submit;
          if(box.scrollIntoView) box.scrollIntoView({behavior:"smooth", block:"center"});
        }
      }catch(e){}
    });
    update();
  }catch(e){}
})();
